import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose, withProps } from 'recompose';
import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

export const TimeEntryGroupFragment = gql`
  fragment TimeEntryGroupFragment on UserDailyTimeEntrySummaryConnection {
    time_entry_group {
      interval {
        iso8601
        dayOfWeek: day_of_week
        display
      }
    }
  }
`;

export const UserDailyTimeEntryGroupFragment = gql`
  fragment UserDailyTimeEntryGroupFragment on UserDailyTimeEntryGroup {
    user {
      id
      firstname
      lastname
      cell_number
      supervisor_id
      default_district {
        id
        name
      }
      supervisor {
        id
        firstname
        lastname
        cell_number
      }
    }
    dailyTimeEntries: daily_time_entries {
      date {
        display
        iso8601
      }
      hasTimeEntries: has_time_entries
    }
    userDailyTimeEntries: user_daily_time_entries {
      id
      requiresTimeEntry: requires_time_entry
      can_set_expects_time_entry
    }
  }
`;

export const GetAllWeeklyTimesheetQuery = gql`
  query GetAllTimesheets {
    all_user_daily_time_entry_groups {
      ...TimeEntryGroupFragment
      edges {
        node {
          ...UserDailyTimeEntryGroupFragment
        }
      }
    }
  }
  ${TimeEntryGroupFragment}
  ${UserDailyTimeEntryGroupFragment}
`;

const withTimesheetData = graphql(GetAllWeeklyTimesheetQuery);

const mapDataToProps = withProps((props) => {
  const { data } = props;
  const userTimesheets = querySelector(data, '$.all_user_daily_time_entry_groups.edges[*].node', []);
  const { interval } = data.all_user_daily_time_entry_groups.time_entry_group;
  return {
    interval,
    userTimesheets,
  };
});

export const queryAllWeeklyTimesheetsGQL = compose(
  withTimesheetData,
  queryMetaHandler,
  mapDataToProps,
  omitProps(['data']),
);
